import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import Date from '../../../common/date';
import Modal from '../../../common/Modal';
import { getById } from '../../../main/barbers/selector';
import { getActiveCashRegisterOpenDate } from '../../cashRegister/selectors';
import BarbersList from './BarbersList';
import SalesSummary from './SalesSummary';
import withCheckShopPermissionPasscode from './withCheckShopPermissionPasscode';
import withFetchSummaryHandler from '../hoc/withFetchSummaryHandler';
import { getSummaryRequest } from '../actions';
import { t } from '../../../../modules/infra/i18n';

const DailyTotalsModal = props => (
  <Modal
    showCloseButton
    className="c-daily-totals-modal"
    display-if={props.isOpen}
    title={props.title}
    close={props.onClose}
  >
    <div className="u-p+">
      <p className="u-font-color-grey">
        {props.openedAt ? (
          <Fragment>
            {t('register:summary.daily_totals_modal.register_opened_at')}{' '}
            <span className="c-opened-time">
              <Date format="MMMM Do, h:mm a">{props.openedAt}</Date>
            </span>
          </Fragment>
        ) : (
          t('register:summary.daily_totals_modal.register_not_opened')
        )}
      </p>
      <div className="o-flexbox u-mt">
        <BarbersList
          display-if={props.shopId}
          shopId={props.shopId}
          selectedBarber={props.selectedBarberId}
          onBarberSelect={props.setSelectedBarberId}
          isLoading={props.isLoading}
          barberIdsWithTransactions={props.barberIdsWithTransactions}
        />
        <SalesSummary
          selectedBarberId={props.selectedBarberId}
          totals={props.totals}
          isLoading={props.isLoading}
        />
      </div>
    </div>
  </Modal>
);

DailyTotalsModal.propTypes = {
  title: PropTypes.string.isRequired,
  openedAt: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  selectedBarberId: PropTypes.string.isRequired,
  setSelectedBarberId: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  shopId: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  onClose: PropTypes.func.isRequired,
  totals: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  barberIdsWithTransactions: PropTypes.array.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  openedAt: getActiveCashRegisterOpenDate(state),
  selectedBarber: getById(state, ownProps.selectedBarberId),
});

export default compose(
  withState('selectedBarberId', 'setSelectedBarberId', null),
  withState('totals', 'setTotals', null),
  withState('isLoading', 'setIsLoading', true),
  withState('barberIdsWithTransactions', 'setBarberIdsWithTransactions', []),
  withHandlers({
    fetchSummary: props => (ownerId, ownerType, from, to, barberIds) => {
      props.setIsLoading(true);

      getSummaryRequest(ownerId, ownerType, from, to, barberIds)
        .then((response) => {
          props.setTotals(response.totals);
          if (!barberIds) {
            props.setBarberIdsWithTransactions(response.barberIds || []);
          }
        })
        .finally(() => props.setIsLoading(false));
    },
  }),
  withCheckShopPermissionPasscode,
  withFetchSummaryHandler,
  lifecycle({
    componentDidMount() {
      this.props.fetchSummaryForBarbers();
    },
    componentDidUpdate(prevProps) {
      if (prevProps.selectedBarberId !== this.props.selectedBarberId) {
        if (this.props.selectedBarberId) {
          this.props.fetchSummaryForBarbers([this.props.selectedBarberId]);

          return;
        }

        this.props.fetchSummaryForBarbers();
      }
    },
  }),
  connect(mapStateToProps), // ORDER IS IMPORTANT DUE TO USAGE OF STATE
)(DailyTotalsModal);
